import { render, staticRenderFns } from "./ListadoGeneralPerseo.vue?vue&type=template&id=8abdac1a&scoped=true"
import script from "./ListadoGeneralPerseo.vue?vue&type=script&lang=js"
export * from "./ListadoGeneralPerseo.vue?vue&type=script&lang=js"
import style0 from "./ListadoGeneralPerseo.vue?vue&type=style&index=0&id=8abdac1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8abdac1a",
  null
  
)

export default component.exports